import React, { Component } from "react";
import ReactIdSwiper from "react-id-swiper";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Magnifier from "react-magnifier";
import Icon from "./Icon";
import { Button, Badge } from "reactstrap";

const customStyles = {
  overlay: {
    zIndex: "1000",
  },
  bodyOpen: {
    position: "fixed",
  },
};

class SwiperGallery extends Component {
  constructor(props) {
    super(props);
  //  console.log("props", props);
    this.state = {
      data: props.data,
      lightBoxOpen: false, //to show fullscreen popup
      activeImage: 0,
      activeSlide: 0,
      isPLP: props.isPLP, //To decide whether to show loghtbox or not
    };
    this.ref = React.createRef(null);

    this.onClick = this.onClick.bind(this);
    this.slideTo = this.slideTo.bind(this);
    this.closeRequest = this.closeRequest.bind(this);

    this.params = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      on: {
        slideChange: () =>
          this.setState({ activeSlide: this.ref.current.swiper.realIndex }),
      },
    };
  }

  closeRequest() {
    this.setState({ lightBoxOpen: false });
    this.forceUpdate();//Sometimes the change happened but will not render, to resolve the issue this method is called
  }

  shouldComponentUpdate(nextProps, nextState) { //To update image when user switch between product using matrix option
    var data =
      nextProps && nextProps.data && nextProps.data[0] && nextProps.data[0].img;
    if (this.state.data != nextProps.data) {
      this.setState({ data: nextProps.data });
      return true;
    } else {
      return false;
    }
  }

  onClick = (index) => {
    this.setState({ activeImage: index });
    this.setState({ lightBoxOpen: !this.state.lightBoxOpen });
    this.forceUpdate();//Sometimes the change happened but will not render, to resolve the issue this method is called
  };

  slideTo = (index) => { //Slider index
    this.setState({ activeSlide: index });
    if (this.ref.current !== null && this.ref.current.swiper !== null) {
      this.ref.current.swiper.slideToLoop(index);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="detail-carousel">
          <ReactIdSwiper {...this.params} ref={this.ref}>
            {this.state.data.map((item, index) => (
              <div key={index}>
                <Magnifier
                  mgShowOverflow={false}
                  mgWidth={2000}
                  mgHeight={2000}
                  className="img-fluid"
                  src={item.img}
                  alt={item.alt}
                  zoomFactor={0.11}
                  style={{ cursor: "default" }}
                />
                {!this.state.isPLP && (
                  <Button
                    color="photoswipe"
                    onClick={() => this.onClick(index)}
                  >
                    <Icon icon="expand-1" className="svg-icon-heavy" />
                  </Button>
                )}
              </div>
            ))}
          </ReactIdSwiper>
        </div>
        {this.state.lightBoxOpen && (
          <Lightbox
            mainSrc={this.state.data[this.state.activeImage].img}
            nextSrc={
              this.state.data[
                (this.state.activeImage + 1) % this.state.data.length
              ].img
            }
            prevSrc={
              this.state.data[
                (this.state.activeImage + this.state.data.length - 1) %
                  this.state.data.length
              ].img
            }
            onCloseRequest={() => this.closeRequest()}
            imageCaption={this.state.data[this.state.activeImage].caption}
            onMovePrevRequest={() =>
              this.setState({
                activeImage:
                  (this.state.activeImage + this.state.data.length - 1) %
                  this.state.data.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                activeImage:
                  (this.state.activeImage + 1) % this.state.data.length,
              })
            }
            enableZoom={false}
            reactModalStyle={customStyles}
          />
        )}
        <div className="swiper-thumbs">
          {this.state.data.map((item, index) => (
            <button
              key={index}
              onClick={() => this.slideTo(index)}
              className={`swiper-thumb-item detail-thumb-item mb-3 ${
                this.state.activeSlide === index ? "active" : ""
              }`}
            >
              <img className="img-fluid" src={item.img} alt={item.alt} />
            </button>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default SwiperGallery;
